import { createApp } from 'vue'
import { Store } from '../model/store/Store'
import Terms from '../component/pages/Terms.vue'

const unsavedPuriCount = document.getElementById('unsavedPuriCount').textContent
const latestImageId = document.getElementById('latestImageId').textContent.replace(/\s+/g, '')

const vue = createApp(
    Terms,
    {
        unsavedPuriCount: unsavedPuriCount,
        latestImageId: latestImageId
    }
)
    .use(Store)
    .mount('#terms')

export default vue
